module.exports = __webpack_public_path__ + "static/img/lifestyle_18.f339bffa.jpg";